export const HOLIDAYS = [];  // No holidays specified by Consumers Energy
